import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'apps/new-web/views/component';
import { connect } from 'react-redux';
import { reduxForm, reducer as form } from 'redux-form';
import createLayout from 'apps/new-web/views/pages/create-layout';
import PasswordField from 'apps/new-web/views/components/password-field';
import PreLoginNavigation from 'apps/new-web/views/components/header';
import MuiButton from '@material-ui/core/Button';
import I18n from 'apps/new-web/views/components/i18n';
import { sendResetPassword, validate } from './form-helper';

const titles = {
  CONFIRMATION: I18n.translate('Your password has been reset!'),
  INVALID_CODE: I18n.translate('This reset password link is invalid or has expired.'),
  RESET_FORM: I18n.translate('Reset your password.')
};

export class PureResetPasswordPage extends BaseComponent {
  static get propTypes() {
    return {
      code: PropTypes.string,
      handleSubmit: PropTypes.func.isRequired,
      invalid: PropTypes.bool,
      invalidCode: PropTypes.bool.isRequired,
      layout: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
        orientation: PropTypes.string,
        mediaType: PropTypes.string
      }),
      submitting: PropTypes.bool
    };
  }

  handleLogin() {
    window.location = '/login';
  }

  handleResetPassword(values) {
    return sendResetPassword(values, this.props.code);
  }

  renderInformationView(title) {
    return (
      <div className="reset-form">
        <h1>{ title }</h1>
        <MuiButton
          className="action-button"
          variant="contained"
          color="primary"
          onClick={ this.handleLogin }
        >
          <I18n>Log In</I18n>
        </MuiButton>
      </div>
    );
  }

  renderForm() {
    const { error, handleSubmit, invalid, submitting } = this.props;
    return (
      <form onSubmit={ handleSubmit(this.handleResetPassword) } className="reset-form">
        <h1>{ titles.RESET_FORM }</h1>
        <PasswordField
          id="reset_password_form-password"
          label={ I18n.translate('New password') }
          name="password"
        />
        <PasswordField
          id="reset_password_form-confirm"
          label={ I18n.translate('Confirm new password') }
          name="confirm"
        />
        { !submitting && error && <p className="error-text">{ error }</p> }
        <MuiButton
          disabled={ submitting || invalid }
          className="action-button"
          variant="contained"
          color="primary"
          type="submit"
        >
          { submitting ?
            <I18n>Resetting...</I18n> :
            <I18n desc="Tells the user to reset their password">Reset Now</I18n>
          }
        </MuiButton>
      </form>
    );
  }

  renderContents() {
    if (this.props.invalidCode) return this.renderInformationView(titles.INVALID_CODE);
    if (this.props.submitSucceeded) return this.renderInformationView(titles.CONFIRMATION);
    return this.renderForm();
  }

  render() {
    return (
      <div className="reset-password-page">
        <PreLoginNavigation />
        <div className="reset-container">
          { this.renderContents() }
        </div>
      </div>
    );
  }
}

const ResetPasswordPage = connect(
  state => ({
    code: state.code,
    invalidCode: !state.isValidCode,
    layout: state.layout
  })
)(reduxForm({
  form: 'resetPassword',
  validate
})(PureResetPasswordPage));

export default createLayout(ResetPasswordPage, { form });
